var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#000105"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.59 10.69C22.5932 10.4708 21.6914 9.94144 21.0141 9.17789C20.3368 8.41435 19.9187 7.45587 19.82 6.44V6H16.37V19.67C16.3707 20.2766 16.1805 20.868 15.8264 21.3604C15.4723 21.8529 14.9723 22.2215 14.3971 22.414C13.8218 22.6065 13.2007 22.6131 12.6215 22.4329C12.0423 22.2527 11.5345 21.8948 11.17 21.41C10.8434 20.9808 10.6435 20.4689 10.5927 19.932C10.542 19.3951 10.6424 18.8548 10.8828 18.372C11.1231 17.8892 11.4937 17.4834 11.9527 17.2003C12.4117 16.9172 12.9407 16.7681 13.48 16.77C13.7782 16.7683 14.075 16.8121 14.36 16.9V13.4C14.0283 13.3589 13.6941 13.3422 13.36 13.35C12.1293 13.3829 10.9349 13.7739 9.92308 14.4753C8.91125 15.1766 8.12589 16.1578 7.66318 17.2986C7.20046 18.4395 7.08048 19.6905 7.31792 20.8986C7.55536 22.1066 8.13991 23.2191 9 24.1C9.88149 24.9962 11.0095 25.6101 12.2407 25.8638C13.4719 26.1175 14.7507 25.9994 15.9147 25.5246C17.0786 25.0498 18.0751 24.2397 18.7776 23.1973C19.4801 22.1548 19.8569 20.9271 19.86 19.67V12.67C21.2515 13.6639 22.92 14.1956 24.63 14.19V10.79C24.2941 10.7914 23.959 10.7579 23.63 10.69H23.59Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokRounded);
export default __webpack_public_path__ + "static/media/tiktok-rounded.2e599e49.svg";
export { ForwardRef as ReactComponent };